import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {
  useGetSubscriptionPurchasesByShopQuery,
  useGetSellVehiclesByShopIdQuery,
  useDeleteSellVehicleMutation,
} from "../../features/shop/shopApiSlice";
import { Col, Row } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";
import ShopAdds from "../shopAds/ShopAdds";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import Suggestion from "../../pages/suggestion";
import Suggestionmodal from "../../pages/suggestionmodal";
import ReportBox from "../Report/index";
import { images } from "../../constants";
import RedoIcon from "@mui/icons-material/Redo";
import ShareModel from "../Sharemodel";
import ShareOption from "../Shareoption";
import "./index.css";
import { getAsset } from "../../helpers/helper";
import dummyezi from "../../assets/images/dummy/dummyezi.png";
import MainModal from "../ui/modal/modal";
import { useSelector } from "react-redux";

const UsedvehicleitemShop = ({
  shopid,
  urlPass,
  btnName,
  name,
  navigateto,
  updateState,
  setSuggest,
  suggest,
  Setreport,
  Report,
  post,
  suggestdata,
  shopData,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: purchaseResponse } = useGetSubscriptionPurchasesByShopQuery(
    shopid || id,
    { skip: !(shopid || id) },
  );
  const subscriptionData = purchaseResponse?.data || purchaseResponse;
  const isHiredSuccess = subscriptionData?.paymentStatus === "success";
  const currentPlan = ["Free", "Basic", "Standard", "Premium"].includes(
    subscriptionData?.planId?.planName,
  )
    ? subscriptionData.planId.planName
    : null;

  const { name: user } = useSelector((state) => state.user);
  const marketerUserId = localStorage.getItem("MeAsmarketerUserId");
  const userId = user?._id?.toString();

  const isOwnerOverride = marketerUserId && userId && marketerUserId === userId;
  const shopUserId =
    shopData?.userid?._id?.toString?.() || shopData?.userid?.toString?.();
  const isOwner = Boolean(userId && shopUserId && shopUserId === userId);

  const canPostItems =
    Boolean(post) &&
    (isOwner ||
      isOwnerOverride ||
      (isHiredSuccess &&
        (currentPlan === "Standard" || currentPlan === "Premium")));

  const location = useLocation();
  const [show, setShow] = useState(false);
  const [showmodal, setShowmodal] = useState(false);
  const [showshare, setShowshare] = useState(false);
  const [itemid, setItemid] = useState();
  const [deleteshow, setDeleteshow] = useState(false);
  const handleClosetwo = () => setShowmodal(0);
  const [shows, setShows] = useState(false);
  const [itemshow, setItemshow] = useState([]);
  const [index, setIndex] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;

  const { data: sellVehiclesResponse } = useGetSellVehiclesByShopIdQuery(id);
  const [deleteSellVehicle] = useDeleteSellVehicleMutation();

  useEffect(() => {
    if (sellVehiclesResponse) {
      let realData = sellVehiclesResponse?.data?.SellVehicles || [];
      let dummiesNeeded = 100 - realData.length;
      let data = realData;
      if (dummiesNeeded > 0) {
        let dummies = Array.from({ length: dummiesNeeded }, (_, i) => ({
          _id: `dummy${i}`,
          brandName: "",
          modelYear: "",
          price: "",
          images: null,
          isDummy: true,
        }));
        data = [...realData, ...dummies];
      }
      setItemshow(data);
    }
  }, [sellVehiclesResponse]);

  const handleSelect = (key) => {
    if (key === "pso") {
      navigate(post);
    }
  };

  const Deleteitem = async () => {
    try {
      const response = await deleteSellVehicle(itemid).unwrap();
      if (response.success) {
        setDeleteshow(false);
        SuccessNotify("Item Deleted Successfully");
      }
    } catch (e) {
      FailedNotify("Failed to Delete Try Again!");
      setDeleteshow(false);
    }
  };
  const handleClose = () => {
    setDeleteshow(false);
  };
  const handleCloseshare = () => {
    setShowshare(0);
    setShow(1);
  };
  const handleShowshare = () => {
    setShow(0);
    setShowshare(1);
  };
  const handleClosemodal = () => {
    setShowmodal(false);
    setShow(0);
  };
  const suggestid = localStorage.getItem("suggestid");

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = itemshow.slice(indexOfFirst, indexOfLast) || [];
  const pageCount = Math.ceil(itemshow.length / itemsPerPage);

  return (
    <>
      <Col lg={12}>
        {deleteshow === true && (
          <MainModal
            variant="deleteModal"
            show={deleteshow}
            title="Profile"
            handleClose={handleClose}
            animation={true}
            handleDelete={Deleteitem}
          />
        )}
        <ShopAdds back="/SellingSide" />
        <ShareOption
          showshare={showshare}
          handleCloseshare={handleCloseshare}
        />
        <ShareModel
          show={showmodal}
          handleClosemodal={handleClosemodal}
          handleShowshare={handleShowshare}
          shopid={shopid || id}
          shareurl={`/used-vehicle-profile/${shopid || id}`}
          shopTitle={shopData?.shopname || ""}
          shopDesc={shopData?.description || ""}
          shopImage={shopData?.image || ""}
        />
        <Row>
          <Col lg={12}>
            {suggest === 1 ? (
              <Suggestionmodal
                setSuggest={setSuggest}
                suggest={suggest}
                suggestdata={suggestdata}
                shopid={shopid}
                shopData={shopData}
              />
            ) : suggest === 2 ? (
              <ReportBox setSuggest={setSuggest} suggest={suggest} />
            ) : suggest === 3 ? (
              <Suggestion
                suggestid={suggestid}
                suggestdata={suggestdata}
                shopData={shopData}
                setSuggest={setSuggest}
              />
            ) : (
              <Tabs
                onSelect={handleSelect}
                id="uncontrolled-tab-example"
                className="mb-3 ps-5"
              >
                <Tab
                  eventKey="jobs"
                  title="RegularItems"
                  className="jobviewhead"
                >
                  <div className="items_scroll noscroll">
                    <div className="row ps-5 pe-5 vehicle-items-grid">
                      {currentItems?.map((Items) => (
                        <div
                          className="col-lg-3 col-xl-3 col-md-6 p-2 vehicle-item-col"
                          key={Items?._id}
                        >
                          <div className="border_2 position-relative">
                            <button
                              className="text-white bg-blue share_font btn-position-absolute"
                              onClick={() => setShowmodal(true)}
                            >
                              Share <RedoIcon className="share_icon_f" />
                            </button>
                            <div>
                              <div className="fix-img">
                                <img
                                  className="c_img"
                                  src={
                                    Items?.isDummy
                                      ? dummyezi
                                      : getAsset(Items?.images)
                                  }
                                  alt=""
                                  crossOrigin="anonymous"
                                />
                              </div>
                              <div className="d-flex justify-content-between pt-1 pb-1 ps-2 pe-2 ">
                                <div>
                                  <p className="mb-0 pt-1  items-card-font font-blue">
                                    {Items?.brandName}
                                  </p>
                                </div>
                                <div> {Items?.modelYear}</div>
                              </div>
                              <div className="d-flex justify-content-between pt-1 pb-1 ps-2 pe-2 ">
                                <div>
                                  <p className="mb-0 pt-1  items-card-font font-blue">
                                    {Items.isDummy ? "" : `PKR ${Items?.price}`}
                                  </p>
                                </div>
                                <div>
                                  {Items.isDummy ? null : (
                                    <img src={images.StarImg} />
                                  )}
                                </div>
                              </div>
                              <div className="d-flex justify-content-around mb-2 mt-1 ps-2 pe-2">
                                {Items.isDummy ? (
                                  <p className="mb-0 text-center font_13 w-100 font-blue pt-4 pb-3 mt-1">
                                    Post item to see here
                                  </p>
                                ) : (
                                  <>
                                    <div>
                                      <p
                                        className="mb-0 text-white view-btn w-100 text-center bg-blue  me-1"
                                        onClick={() =>
                                          navigate(
                                            `/vehicle-add/${Items?._id}/${shopid}`,
                                          )
                                        }
                                      >
                                        View
                                      </p>
                                    </div>
                                    <div>
                                      <p
                                        className="mb-0 delete-btn w-100 text-center text-white bg-red me-1"
                                        onClick={() => {
                                          setDeleteshow(true);
                                          setItemid(Items?._id);
                                        }}
                                      >
                                        Delete
                                      </p>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                      <Pagination>
                        <Pagination.First
                          onClick={() => setCurrentPage(1)}
                          disabled={currentPage === 1}
                        />
                        <Pagination.Prev
                          onClick={() => setCurrentPage(currentPage - 1)}
                          disabled={currentPage === 1}
                        />
                        {Array.from({ length: pageCount }).map((_, idx) => (
                          <Pagination.Item
                            key={idx + 1}
                            active={idx + 1 === currentPage}
                            onClick={() => setCurrentPage(idx + 1)}
                          >
                            {idx + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next
                          onClick={() => setCurrentPage(currentPage + 1)}
                          disabled={currentPage === pageCount}
                        />
                        <Pagination.Last
                          onClick={() => setCurrentPage(pageCount)}
                          disabled={currentPage === pageCount}
                        />
                      </Pagination>
                    </div>
                  </div>
                </Tab>

                {canPostItems && (
                  <Tab
                    id="uncontrolled-tab-example-tab-pso"
                    className="tab_postset"
                    eventKey="pso"
                    title="&#10133; Post Item"
                    onClick={() => navigate(`${post}/` + id)}
                  ></Tab>
                )}
              </Tabs>
            )}
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default UsedvehicleitemShop;
